import React from 'react';

import { useColorMode } from '@atlaskit/app-provider';

export const GenericErrorIcon = (): React.JSX.Element => {
	const theme = useColorMode();
	const isDarkTheme = theme === 'dark';
	const fillColour = isDarkTheme ? '#4B4D51' : '#DDDEE1';
	const innerColour = isDarkTheme ? '#101214' : 'white';
	return (
		<svg
			data-testid="navigation-empty-state--generic-error-icon"
			width="57"
			height="53"
			viewBox="0 0 57 53"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M0 52.5871L0.0314182 52.6499H56.8739L56.9088 52.5871L28.4544 0L0 52.5871Z"
				fill={fillColour}
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M27.2725 38.0368V18.8333H29.8313V38.0368H27.2725Z"
				fill={innerColour}
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M28.0814 41.2098C28.2675 41.1764 28.4451 41.1665 28.5973 41.1665C28.7583 41.1665 28.9179 41.1777 29.0781 41.2023L29.084 41.2032L29.0899 41.2042C30.1047 41.37 30.9494 42.0762 31.154 43.2046C31.19 43.3958 31.1998 43.5794 31.1998 43.7306C31.1998 43.8478 31.1939 43.9799 31.1754 44.1197V44.1412L31.1552 44.2533C30.9533 45.3786 30.1106 46.0937 29.0899 46.2604L29.084 46.2614L29.0781 46.2623C28.9179 46.287 28.7583 46.2981 28.5973 46.2981C28.444 46.2981 28.2649 46.2881 28.0772 46.2541C27.0757 46.0805 26.2351 45.3807 26.0303 44.2574C25.9948 44.0692 25.9844 43.8932 25.9844 43.7341C25.9844 43.5767 25.9945 43.3951 26.0311 43.2033C26.2382 42.0971 27.0613 41.3814 28.0814 41.2098ZM28.5432 43.7274C28.5432 43.7295 28.5432 43.7318 28.5432 43.7341C28.5432 43.7352 28.5432 43.7362 28.5432 43.7373C28.5444 43.7374 28.5456 43.7375 28.547 43.7376C28.559 43.7385 28.5757 43.7393 28.5973 43.7393C28.6137 43.7393 28.6281 43.7389 28.6409 43.7381C28.6409 43.7357 28.641 43.7332 28.641 43.7306C28.641 43.7292 28.641 43.7278 28.6409 43.7265C28.6282 43.7258 28.6137 43.7253 28.5973 43.7253C28.5757 43.7253 28.559 43.7261 28.547 43.727C28.5457 43.7272 28.5444 43.7273 28.5432 43.7274Z"
				fill={innerColour}
			/>
		</svg>
	);
};
